<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <!-- <Sidebar></Sidebar> -->

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <div class="hidden-xs">    
                        <center>
                            <img src="static/config/logo.png" class="logo-inicio">
                        </center>
                    </div>      


                    <div class="hidden-xs row margin-bottom-30">
                        <div class="col-xl-12">
                            <button class="button small gray" type="button" v-on:click="$root.back()">
                                <i class="las la-arrow-left"></i> Voltar
                            </button>
                        </div>
                    </div>

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs margin-bottom-20">
                        <h3>
                            <img src="static/images/icones/receipt.png" style="height: 50px">
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row">
                       
                        <!-- Dashboard Box -->
                        <div class="col-xs-12 col-xl-12 col-lg-12">
                            <div class="page-text margin-bottom-30">
                                <div class="row">
                                    <div class="col-xs-3 hidden-xl hidden-lg hidden-md">
                                        <img class="" src="static/images/icones/receipt.png" style="width: 100%; height: auto;">
                                    </div>
                                    <div class="col-xs-9 col-lg-12 col-xl-12 col-md-12">
                                        <p class="margin-bottom-0">
                                            Gestor! Ao aprovar pedidos no sistema Clinic, você estará utilizando valores do seu orçamento mensal.<br>Solicitamos que verifique com atenção as informações preenchidas, como fornecedor, valor e demais observações.<br>Em caso de reprovação, solicitamos que informe o colaborador para que um novo pedido seja realizado, se houver necessidade.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>                               
                        <div class="col-xl-12">
                            <form v-show="mostrarFiltro" method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get" novalidate>
                                <div class="row right-xs">

                                    <div class="hidden-xl hidden-lg hidden-md col-xs-12" style="text-align: right;">
                                        <button type="button" v-on:click="mostrarFiltro = false;" class="button small gray margin-bottom-20">
                                            <i class="las la-angle-up"></i>
                                            Esconder filtros
                                        </button>      
                                    </div>

                                    <div class="col-lg-4 col-xs-6 col-xl-2 col-md-5">
                                        <div class="submit-field">
                                            <h5>De:</h5>
                                            <input type="date" data-placeholder="__ /__ /____" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-lg-4 col-xs-6 col-xl-2 col-md-5">
                                        <div class="submit-field">
                                            <h5>Até:</h5>
                                            <input type="date" data-placeholder="__ /__ /____" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>   
                                    <div class="col-lg-3 col-xs-6 col-xl-3 col-md-6" style="padding-right: 0px;">
                                        <div class="submit-field">
                                            <h5>Centro de custo:</h5>
                                            <select class="with-border" v-model="form.centroCusto">
                                                <option default="" value="">Selecione..</option>
                                                <option v-for="(item, index) in centroCusto.itens" :key="'centro-custo' + item.CD_CENTRO_CUSTO" :value="item.CD_CENTRO_CUSTO">{{item.DS_CENTRO_CUSTO}}</option>
                                            </select>
                                        </div>
                                    </div>   
                                    <div class="col-lg-4 col-xs-6 col-xl-3 col-md-6" style="padding-right: 0px;">
                                        <div class="submit-field">
                                            <h5>Origem:</h5>
                                            <select class="with-border" v-model="form.itemServico">
                                                <option default="" value="">Selecione..</option>
                                                <option value="Requisições de Consumo">Requisições de Consumo</option>
                                                <option value="Ordens de Compra">Ordens de Compra</option>
                                                <option value="Solicitações de Compra">Solicitações de Compra</option>
                                                <option value="Títulos a pagar">Títulos a pagar</option>
                                            </select>
                                        </div>
                                    </div>                                         
                                    <div class="col-lg-4 col-xs-12 col-xl-3 col-md-6">
                                        <div class="submit-field">
                                            <h5>Solicitante:</h5>
                                            <input type="text" class="with-border margin-bottom-0" placeholder="Escreva o nome.." name="pesquisa" v-model="form.solicitante">
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-xs-6 col-xl-2 col-md-4" style="padding-right: 0px;">
                                        <div class="submit-field">
                                            <h5>Status:</h5>
                                            <select class="with-border" v-model="form.status">
                                                <option default="" value="">Selecione..</option>
                                                <option value="P">Pendente</option>
                                                <option value="A">Aprovado</option>
                                                <option value="R">Reprovado</option>
                                                <option value="B">Baixado</option>                                
                                            </select>
                                        </div>
                                    </div>     
                                    <div class="col-lg-3 col-xs-6 col-xl-3 col-md-4" style="padding-right: 0px;">
                                        <div class="submit-field">
                                            <h5>Tipo do pedido:</h5>
                                            <select class="with-border" v-model="form.tipo">
                                                <option default="" value="">Selecione..</option>
                                                <option value="Despesa Corrente">Despesa Corrente</option>
                                                <option value="Planejamento estratégico">Planejamento estratégico</option>
                                            </select>
                                        </div>
                                    </div>                                                                        
                                    <div class="col-lg-3 col-md-2 col-xs-4 hidden-xs hidden-md">
                                        <div class="submit-field">
                                            <div class="hidden-xs clearfix" style="margin-top: 21px;"></div>
                                            <button class="button small green" style="height: 40px;">
                                                <i class="las la-search"></i>
                                                Pesquisar
                                            </button>  
                                            <button type="button" v-on:click="mostrarFiltro = false;" class="button small gray" style="height: 40px;">
                                                <i class="las la-angle-up"></i>
                                                Esconder filtros
                                            </button>                                                                                      
                                        </div>
                                    </div>
                                    <div class="col-xs-7 margin-bottom-20 padding-top-12 col-md-7">
                                        <small style="display: block; line-height: 130%"><b>{{data.total}}</b> resultado(s) encontrado(s).</small>
                                    </div>

                                    <div class="col-lg-3 col-md-3 col-xs-5 hidden-xl hidden-lg" style="text-align: right;">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg margin-top-10"></div>
                                            <div class="hidden-xs hidden-md clearfix" style="margin-top: 32px;"></div>
                                            <button class="button small green block-mobile">
                                                <i class="las la-search"></i>
                                                Pesquisar
                                            </button> 

                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl hidden-lg margin-top-20"></div>
                            </form> 

                            <button v-if="!mostrarFiltro" type="button" v-on:click="mostrarFiltro = true;" class="hidden-lg hidden-md hidden-xl button small gray margin-bottom-20 float-right">
                                <i class="las la-angle-down"></i>
                                Mostrar filtros
                            </button>

                            <button v-if="!mostrarFiltro" type="button" v-on:click="mostrarFiltro = true;" class="hidden-xs button small gray margin-bottom-20">
                                <i class="las la-angle-down"></i>
                                Mostrar filtros
                            </button>                            

                            <div class="clearfix"></div>

                            <h5 v-show="data.itens.length == 0 && data.loaded" class="empty">
                                <i class="las la-times"></i>
                                Nenhum resultado encontrado.
                            </h5>

                            <div class="table-scroll" style="overflow-x: scroll; border: 1px solid #ddd" v-show="data.itens.length > 0">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 70px; width: 70px;">
                                            Número
                                        </th>
                                        <th style="min-width: 150px; width: 150px;">
                                            Ações
                                        </th>                                                                     
                                        <th style="min-width: 200px;">
                                            Solicitante
                                        </th>
                                        <th style="min-width: 270px; width: 270px;" >
                                            Tipo
                                        </th>                                        
                                        <th style="min-width: 200px; width: 200px;">
                                            Origem
                                        </th>
                                        <th style="min-width: 200px; width: 200px;">
                                            Centro de Custo
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Status
                                        </th>                                        
                                        <th style="min-width: 130px; width: 130px;">
                                            Valor
                                        </th>    
                                        <th style="min-width: 100px; width: 100px;">
                                            Data de entrega
                                        </th>
                                    </thead>
                                    <tbody>   

                                        <tr v-for="(item, index) in data.itens" :key="index + '-' + item.NR_SEQ_APROVACAO">
                                            <td data-label="">
                                                <span class="hidden-xl hidden-lg" style="font-size: 16px; font-weight: 500">Número: #{{item.NR_DOCUMENTO}}</span><span style="font-size: 16px; font-weight: 500;" class="hidden-xs">#{{item.NR_DOCUMENTO}}</span>
                                            </td>
                                            <td data-label="Ações">
                                                <a v-on:click="$root.go('FinanceiroSolicitacoesDetalhes', JSON.stringify({'NR_SEQ_APROVACAO': item.NR_SEQ_APROVACAO, 'NR_SEQ_PROCESSO': item.NR_SEQ_PROCESSO}))" class="dashboard-status-button color-primary block-mobile cursor-pointer" style="font-size: 15px; font-weight: 500">
                                                    <i class="las la-edit"></i>
                                                    Ver solicitação
                                                </a>
                                            </td>                                            
                                            <td data-label="Solicitante">
                                                {{item.SOLICITANTE}}
                                            </td>
                                            <td data-label="Tipo">
                                                <span class="dashboard-status-button gray cursor-pointer" v-on:click="mostrarEditarTipo(item)" style="margin-right: 2px; font-weight: 500;">
                                                    <i style="color: #333 !important" class="las la-angle-down" v-if="!item._EDITAR"></i> 
                                                    <i style="color: #333 !important" class="las la-angle-up" v-if="item._EDITAR"></i> 
                                                    Editar
                                                </span>

                                               {{item.IE_TIPO}}

                                               <small v-if="item.IE_TIPO == 'Planejamento estratégico'" class="block" style="color: #666; margin-top: 10px; word-break: break-word;">Etapa: {{item.DS_ETAPA}}</small>

                                               <div class="row margin-top-20" v-show="item._EDITAR">
                                                    <div class="col-xs-12" >
                                                        <h5 style="border-top: 1px solid #ddd; padding-top: 10px;">Vincular ação P.E.</h5>
                                                        <select class="with-border margin-bottom-0" v-model="item.NR_SEQ_ETAPA" style="font-size: 14px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                                                            <option value="">Selecione..</option>
                                                            <option v-for="(item2, index) in item.acoes" :value="item2.NR_SEQ_ETAPA">{{item2.DS_ETAPA}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-xs-12">
                                                        <button type="button" v-on:click="editarTipo(item)" class="button small green cursor-pointer" style="display: block; width: 100%">
                                                            <i class="las la-save" style="color: #fff; top: 0px;"></i>
                                                            Confirmar alteração
                                                        </button>
                                                    </div>
                                               </div>

                                            </td>                                             
                                            <td data-label="Origem">
                                               {{item.ITEM_SERVICO}}
                                            </td>   
                                            <td data-label="Centro de Custo">
                                               {{item.DS_CENTRO_CUSTO}}
                                            </td>                                               
                                            <td data-label="Status">
                                               <span v-if="item.IE_APROV_REPROV == 'P'" class="dashboard-status-button color-orange">Pendente</span>
                                               <span v-if="item.IE_APROV_REPROV == 'B'" class="dashboard-status-button color-blue">Baixado</span>
                                               <span v-if="item.IE_APROV_REPROV == 'A'" class="dashboard-status-button color-green">Aprovado</span>
                                               <span v-if="item.IE_APROV_REPROV == 'R'" class="dashboard-status-button color-red">Reprovado</span>
                                            </td>    
                                            <td data-label="Valor">
                                               R$ {{item.VL_TOTAL | toMoney}}
                                            </td>                                                  
                                            <td data-label="Data de entrega">
                                               {{item.DT_ENTREGA | formatDate2}}
                                            </td>  
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div class="pagination-container margin-top-60 margin-bottom-60">
                                <nav class="pagination">
                                    <ul>
                                        <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get();">
                                            <a>
                                                <i class="las la-arrow-left"></i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get();">
                                            <a>
                                                Próxima
                                                <i class="las la-arrow-right"></i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="(item, index) in data.pages" v-show="item.show">
                                            <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get();">
                                                {{item.index}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>                                
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'FinanceiroSolicitacoes',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
        },          
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        } ,
        formatDate2: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            return date;
        }          
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "mostrarFiltro":        true,
            "data":                 {
                "itens":            [],
                "total":            0
            },
            "centroCusto":          {
                "itens":            [],
                "total":            0
            },
            "acoes":                {
                "itens":            [],
                "total":            0
            },                        
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "solicitante":      "",
                "status":           "P",
                "dataInicio":       "",
                "dataFinal":        "",
                "tipo":             "",
                "itemServico":      "",
                "centroCusto":      "",
                "page":             1,
                "pesquisa":         ""
            }              
        }
    },
    methods: {    
        editarTipo: function(item) {
            console.log("editarTipo()", item);
            var self = this;

            return new Promise(function(resolve, reject) {
                confirm("Você tem certeza que deseja " + (item.NR_SEQ_ETAPA == 1 ? "desvincular" : "vincular") + " a ação selecionada?", function() {
                   
                    loading.show();

                    var form = {
                        "_cod":             self.$root.user.cod, 
                        "_token":           self.$root.user.token,
                        "acao":             "vincular-acao",
                        "NR_SEQ_PROCESSO":  item.NR_SEQ_PROCESSO,
                        "NR_SEQ_APROVACAO": item.NR_SEQ_APROVACAO,
                        "NR_SEQ_ETAPA":     item.NR_SEQ_ETAPA
                    };
                        
                    axios.put("api/financeiro-solicitacoes.php", form, {"timeout": 300000})
                    .then(response => {

                        console.log("vincular-acao()", "success", response.data)
                        alert(response.data.message);
                        self.get();
                        // loading.hide();
                        resolve(response);

                    })
                    .catch(error => {

                        reject(error);
                        console.log("vincular-acao()", "error", error.data)
                        loading.hide();
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                    });
                });
            });   
        },
        mostrarEditarTipo: function(item) {
            var self = this;
            item._EDITAR = (!item._EDITAR ? true : false);
            if (!item.NR_SEQ_ETAPA) {
                item.NR_SEQ_ETAPA = "";
            }
            self.$forceUpdate();
        },
        get: function(noScroll) {
            var self        = this;
            console.log("get()", self.form);
            loading.show();


            return new Promise(function(resolve, reject) {

                axios.get("api/financeiro-solicitacoes.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    if (!noScroll) {
                        self.$root.scrollTop();
                    }

                    self.$root.tmp.financeiroSolicitacoes           = JSON.parse(JSON.stringify(response.data.result));
                    self.$root.tmp.financeiroSolicitacoesForm       = JSON.parse(JSON.stringify(self.form));

                    self.$forceUpdate();
                    self.$root.$forceUpdate();

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getCentroCusto: function() {
            var self        = this;
            console.log("getCentroCusto()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "centro-de-custo"
                    }
                };

                axios.get("api/financeiro.php", form)
                .then(response => {
                    
                    console.log("getCentroCusto() response", response);
                    self.centroCusto   = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCentroCusto() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },  
        getAcoes: function() {
            var self        = this;
            console.log("getAcoes()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "acoes"
                    }
                };

                axios.get("api/financeiro.php", form)
                .then(response => {
                    
                    console.log("getAcoes() response", response);
                    self.acoes          = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getAcoes() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }       
    },
    created: function() {
        var self = this;
        // self.get();
        console.log("Aprovação Orçamentária -> created")
        loading.hide();
    },
    mounted: function() {
        var self = this;
        console.log("Aprovação Orçamentária -> mounted")

        if (self.$root.mobile.isMobile) {
            self.mostrarFiltro = false;
        }

        var noScroll    = false;

        if (self.$root.tmp.financeiroSolicitacoes) {

            self.form   = JSON.parse(JSON.stringify(self.$root.tmp.financeiroSolicitacoesForm));
            self.data   = JSON.parse(JSON.stringify(self.$root.tmp.financeiroSolicitacoes));
            self.$root.$forceUpdate();
            self.$forceUpdate();
            noScroll    = true;
        }

        Promise.all([
            self.get(noScroll),
            self.getCentroCusto(),
            self.getAcoes(),
        ]).then(function() {
            self.initLoaded = true;
            
            if (self.$root.loaded) {
                if (window.__app.$route.name == "Dashboard") {
                    loading.hide();
                }
            }
        }).catch(function(error) {
            // loading.hide();
            self.initLoaded = true;
            self.$forceUpdate();  
            if (self.$root.loaded) {

                loading.hide();
            }              
        });          
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .submit-field {
        margin-bottom: 15px;
    }

    .dashboard-status-button i {
        color: #fff !important;
    }

    .dashboard-status-button.block-mobile {
        text-align: center !important;
        font-weight: 400;
/*        font-size: 13px;*/
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/FinanceiroSolicitacoes.vue